import store from '@/store'
import sweetalertUtil from '@/utils/sweetalertUtil'
import i18n from '@/translations'
import {checkPermission} from '@/utils/permissionsUtil'

const verifyTokenGuard = async (to, from, next) => {

    const token = store.getters["auth/getToken"]
    const isExpired = store.getters['auth/isExpired']
    const loggedUser = store.getters['auth/getLoggedUser']
    const isNeedsAcceptNoticeOfPrivacy = store.getters['auth/getIsNeedsAcceptNoticeOfPrivacy']

    if (isNeedsAcceptNoticeOfPrivacy) {
        next({name: 'notice_privacy-index'})
    } else if (isExpired) {

        const {message, error} = await store.dispatch('auth/refreshToken')

        if (error) {

            await store.dispatch('auth/clearAuthToken')

            if (message != "") {

                // sweetalertUtil.fire({
                //     icon: 'error',
                //     title: i18n.global.messages.value[i18n.global.locale.value]["alert-title-message"],
                //     html: message,
                //     confirmButtonText: i18n.global.messages.value[i18n.global.locale.value]["accept"],
                // })

            }

            next({name: 'auth-login'})
        }

        if (checkPermission(to.name)) {
            next()
        } else {

            sweetalertUtil.fire({
                icon: 'error',
                title: 'Error',
                html: i18n.global.messages.value[i18n.global.locale.value]['errors']['has-permission'],
            })
            next({name: from.name})
        }

    } else if (!token || isExpired) {
        next({name: 'auth-login'})
    } else {

        //Needs to change password
        const passwordExpired = store.getters['auth/isPasswordExpired']
        const forcePasswordChange = store.getters['auth/isForcePasswordChange']

        if (passwordExpired) {
            next({name: 'change-password-expired-edit'})
        } else if (forcePasswordChange) {
            // Determinar la ruta de perfil según el tipo de usuario
            const isPatient = loggedUser?.role_name === 'Paciente'
            const profileRoute = isPatient ? 'patient-profile-edit' : 'profile-edit'
            
            // Solo redirigir si no está yendo ya a su ruta de perfil correspondiente
            if (to.name !== profileRoute) {
                // Mostrar alerta y redirigir al perfil si necesita completarlo
                sweetalertUtil.fire({
                    icon: 'warning',
                    title: i18n.global.messages.value[i18n.global.locale.value]['force-complete-profile']['title'] || 'Acción requerida',
                    html: i18n.global.messages.value[i18n.global.locale.value]['force-complete-profile']['alert-message'] || 'Para garantizar la seguridad de tu cuenta y el correcto funcionamiento del sistema, debes cambiar tu contraseña temporal y completar tu información de perfil.',
                    confirmButtonText: i18n.global.messages.value[i18n.global.locale.value]['accept'] || 'Aceptar',
                })
                next({name: profileRoute})
            } else {
                next()
            }
        } else if (checkPermission(to.name)) {
            next()
        } else {
            sweetalertUtil.fire({
                icon: 'error',
                title: 'Error',
                html: i18n.global.messages.value[i18n.global.locale.value]['errors']['has-permission'],
            })
            next({name: from.name})
        }

    }

}

export default verifyTokenGuard
